import apiService from './apiService';
import authService from './authService';
import { MENU_CATALOG, resolveMenuKeyForPath } from '../config/menuCatalog';

let cache = null;
let loadPromise = null;

async function request(promise) {
  const res = await promise;
  if (!res.success) {
    throw new Error(res.message || 'Erreur API');
  }
  return res;
}

function allKeysVisibleCache() {
  const keys = MENU_CATALOG.map((item) => item.key);
  return {
    bypass: authService.isSuperAdmin(),
    visibleKeys: new Set(keys),
    visibility: Object.fromEntries(keys.map((k) => [k, true])),
    catalog: MENU_CATALOG,
    loadError: true,
  };
}

const menuVisibilityService = {
  clear() {
    cache = null;
    loadPromise = null;
  },

  getCached() {
    return cache;
  },

  async load(force = false) {
    if (!authService.isAuthenticated()) {
      this.clear();
      return null;
    }
    if (!force && cache && !cache.loadError) {
      return cache;
    }
    if (!force && loadPromise) {
      return loadPromise;
    }

    loadPromise = request(apiService.get('/menu-visibility/me'))
      .then((res) => {
        cache = {
          bypass: Boolean(res.data?.bypass),
          visibleKeys: new Set(res.data?.visible_keys ?? []),
          visibility: res.data?.visibility ?? {},
          catalog: res.data?.catalog ?? [],
          loadError: false,
        };
        return cache;
      })
      .catch((err) => {
        console.warn('Visibilité menus indisponible, fallback permissif:', err.message);
        cache = allKeysVisibleCache();
        loadPromise = null;
        return cache;
      });

    return loadPromise;
  },

  canSee(key) {
    if (!key) return true;
    if (authService.isSuperAdmin()) return true;
    if (!cache) {
      return false;
    }
    if (cache.bypass) return true;
    return cache.visibleKeys.has(key);
  },

  canAccessPath(pathname) {
    if (authService.isSuperAdmin()) return true;
    const key = resolveMenuKeyForPath(pathname);
    if (!key) return true;
    if (!cache) return false;
    if (cache.bypass) return true;
    return cache.visibleKeys.has(key);
  },

  isLoaded() {
    return cache != null || authService.isSuperAdmin();
  },

  async getAdminMatrix() {
    const res = await request(apiService.get('/menu-visibility/admin'));
    return res.data ?? {};
  },

  async saveAdminMatrix(matrix) {
    const res = await request(apiService.put('/menu-visibility/admin', { matrix }));
    this.clear();
    return res.data ?? {};
  },
};

export default menuVisibilityService;
